export default __webpack_public_path__ + "static/media/divider.cc8b75a7.svg";